import { useDesignMaxTheme } from "@/packages";
import { Box } from "@chakra-ui/react";
import { type ControlDotsProps } from "./controlDots.type";

export const ControlDots = ({ childLength, currentIdx, goSlide, isNavigateRadio = true }: ControlDotsProps) => {
    const { MEDIAS, COLORS } = useDesignMaxTheme();
    const { isMobile, isLaptop } = MEDIAS();
    return (
        <Box
            position="absolute"
            display={isMobile ? "none" : "flex"}
            right={isLaptop ? "48px" : "184px"}
            top="50%"
            flexDir="column"
            rowGap="24px"
            transform="translateY(-50%)"
        >
            {isNavigateRadio &&
                Array.from({ length: childLength }).map((_, index) => (
                    <Box
                        key={Math.random()}
                        w="16px"
                        h="16px"
                        borderRadius="50%"
                        border={`2px solid ${COLORS.white}`}
                        backgroundColor={currentIdx - 1 === index ? `${COLORS.blue[200]}` : "transparent"}
                        cursor="pointer"
                        onClick={() => goSlide(index + 1)}
                    />
                ))}
        </Box>
    );
};
